import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, CheckCircle2 } from 'lucide-react';
const features = ['Cómo auditar tu reporte desde cero usando la Ley FCRA como tu escudo legal personal.', 'El proceso exacto para identificar errores factuales que los burós están obligados por ley a corregir.', 'Cómo construir un perfil crediticio sólido agregando historial positivo sin depender de agencias costosas.'];
export function FeaturesSection() {
  return <section className="py-20 px-4 bg-zenith-card relative border-y border-white/5" data-id="element-5">
      <div className="max-w-4xl mx-auto" data-id="element-6">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex items-center justify-center mb-12" data-id="element-7">
          <BookOpen className="w-8 h-8 text-zenith-red mr-4" data-id="element-8" />
          <h2 className="text-3xl md:text-4xl font-bold text-white text-center" data-id="element-9">
            Lo que aprenderás en este ebook:
          </h2>
        </motion.div>

        <div className="space-y-6" data-id="element-10">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15
        }} className="flex items-start p-6 bg-zenith-bg rounded-xl border border-white/5 hover:border-zenith-red/30 transition-colors" data-id="element-11">
              <CheckCircle2 className="w-6 h-6 text-zenith-red shrink-0 mt-1 mr-4" data-id="element-12" />
              <p className="text-lg text-zenith-muted leading-relaxed" data-id="element-13">
                {feature}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}